// extracted by mini-css-extract-plugin
module.exports = {"container":"OneyBanner_container__2t7V1","oneyIcon":"OneyBanner_oneyIcon__RAS5c","helpIcon":"OneyBanner_helpIcon__1D7-5"};